import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { isLoadingCommonFilters } from "@signals"
import { areCommonFiltersValid, commonFilterErrors } from "@signals/commonFilters/filters"
import { Box, Typography } from "@mui/material"
import { batch } from '@preact/signals-react'
import { BIGoalMissing, BISelectedOffice } from '../@signals'
import { missingLabels } from '../@services/submit'
import { BIStartFromQuestion } from '../Goals'
import { dsColorNew } from '@palette'
import { filterSearchButtonProps } from "@components/@base/FilterPanel"


export default function BIFiltersFooterActions() {
	const ready = areCommonFiltersValid.value && !BIGoalMissing.value?.length
	// what keeps Search disabled, next to it (CU-869fmk5ge, UX Obs. 5)
	const missing = ready ? [] : missingLabels(commonFilterErrors.value, BIGoalMissing.value)

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1.5, flex: 1 }}>
		<BIStartFromQuestion/>
		<Box sx={{ flex: 1 }}/>
		{!!missing.length && <Typography sx={{ fontSize: 12.5, color: dsColorNew.noteAmber }}>Missing: {missing.join(', ')}</Typography>}
		<ButtonLoadingSeeker
			loading={isLoadingCommonFilters.value}
			{...filterSearchButtonProps}
			onClick={() => batch(() => {
				BISelectedOffice.value = null
				isLoadingCommonFilters.value = true
			})}
			disabled={!ready}
		>
			Search
		</ButtonLoadingSeeker>
	</Box>
}